import React, { useState, useRef, useEffect } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import Odometer from 'react-odometerjs';

import commercialLines from '../../../assets/images/commercialLines.png';
import nextGen from '../../../assets/images/fortyFivePlus.png';
import people from '../../../assets/images/oneTwentyNine.png';
import medalIcon from '../../../assets/images/medalIcon2.png';
import greenUpArrow from '../../../assets/images/greenUpArrow.png';
import blueTooth from '../../../assets/images/blueTooth.png'

const JSON1 = `{`;
const JSON2 = `}`;

const Highlights = ({ isMobile }) => {
  return (
    <Col>
      <Row>
        <Col>
          <h2
            id="2021-highlights"
            tabIndex="-1"
          >
            2021 high{isMobile && "-"}{isMobile && <br />}lights
          </h2>
        </Col>
      </Row>
      <Row style={{ marginTop: 30, marginBottom: 60 }}>
        <Col>
          <p>
            2021 was a year of taking everything to the next level. We couldn't accomplish this without our members. Every step forward is based on collaboration—understanding members' pain points, examining solutions, then implementing and educating so every member can benefit.
          </p>
        </Col>
      </Row>

      <Row style={{ marginTop: 30 }}>
      <Col xs={12} sm={12} md={12} lg={6} xl={4} style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'column',
          marginBottom: 30,
          alignItems: 'center'
        }}>
          <NextGenerationHighlight />
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={4} style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'column',
          marginBottom: 30,
          alignItems: 'center'
        }}>
          <FourMillion />
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={4} style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'column',
          marginBottom: 30,
          alignItems: 'center'
        }}>
          <CommercialLinesDataStandards />
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={4} style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'column',
          marginBottom: 30,
          alignItems: 'center'
        }}>
          <FirstInsurer />
        </Col>
      {/* </Row>

      <Row> */}
      <Col xs={12} sm={12} md={12} lg={6} xl={4} style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'column',
          marginBottom: 30,
          alignItems: 'center'
        }}>
          <OneHundredSixtyOnePercent />
        </Col>

        <Col xs={12} sm={12} md={12} lg={6} xl={4} style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'column',
          marginBottom: 30,
          alignItems: 'center'
        }}>
          <FirstInTheIndustryJSONAPI />
        </Col>

        <Col xs={12} sm={12} md={12} lg={6} xl={6} style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'column',
          marginBottom: 30,
          alignItems: 'center'
        }}>
          <FirstInsurerAndVendor />
        </Col>

        <Col xs={12} sm={12} md={12} lg={6} xl={6} style={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'column',
          marginBottom: 30,
          alignItems: 'center'
        }}>
          <FourteenHundredHighlight />
        </Col>
      </Row>

    </Col>
  )
}

export default Highlights;

const FourteenHundredHighlight = () => (
  <div style={{
    width: 300,
    height: 300,
    borderRadius: '50%',
    backgroundColor: '#FDF2D6',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}>
    <img
      src={people}
      width="60px"
      height="60px"
      alt="mobile divice icon"
      style={{
        position: 'absolute',
        bottom: 220,
      }}
    />
    <div style={{
      marginTop: 25,
      width: 260,
      height: 260,
      borderRadius: 150,
      // backgroundColor: '#FDF2D6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      fontFamily: '',
      paddingTop: 12,
    }}>
      <div>
        <Odom format="(,ddd)" number={1400} text="" odomStyle={{
          fontSize: 64,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#175C73',
          padding: 0,
        }} />
      </div>
      <div style={{
        marginTop: -12,
        fontSize: 18,
        fontFamily: 'montserrat medium',
        fontWeight: 'bold',
        color: '#175C73',
        textAlign: 'center',
        lineHeight: 1,
        padding: 4,
      }}>
        MEMBERS
      </div>
      <div style={{
        fontSize: 14,
        fontFamily: 'montserrat medium',
        fontWeight: 'bold',
        color: '#3E6047',
        textAlign: 'center'
      }}>
        REGISTER FOR THE DIGITAL
      </div>
      <div style={{
        fontSize: 14,
        fontFamily: 'montserrat medium',
        fontWeight: 'bold',
        color: '#3E6047',
        textAlign: 'center'
      }}>
        MEMBERS PROGRAM—
      </div>
      <div style={{
        fontSize: 18,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#175C73',
        textAlign: 'center',
        lineHeight: 1.5,
        padding: 0,
      }}>
        RECORD NUMBER OF
      </div>
      <div style={{
        fontSize: 18,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#175C73',
        textAlign: 'center'
      }}>
        ENROLLMENT
      </div>
    </div>
  </div>
)

const CommercialLinesDataStandards = () => (
  <div  style={{
    width: 300,
    height: 300,
    borderRadius: '50%',
    backgroundColor: '#FDFAE7',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    
  }}>
    <img
      src={commercialLines}
      width="52px"
      height="60px"
      alt="mobile divice icon"
      style={{
        position: 'absolute',
        bottom: 210,
      }}
    />
    <div style={{
      // marginTop: 25,
      width: 260,
      height: 260,
      borderRadius: 150,
      // backgroundColor: '#FDFAE7',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      fontFamily: '',
      paddingTop: 60,
    }}>
      <div style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        textAlign: 'center'
      }}>
        COMMERCIAL LINES
      </div>
      <div style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        textAlign: 'center'
      }}>
        DATA STANDARDS
      </div>
      <div style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        textAlign: 'center'
      }}>
        COMPLETED FOR:
      </div>
      <div style={{
        fontSize: 22,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#07527F',
        textAlign: 'center',
        lineHeight: 1.2,
        padding: 0,
      }}>
        MULTI-OPERATIONS
      </div>
      <div style={{
        fontSize: 22,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#07527F',
        textAlign: 'center',
        lineHeight: 1.2,
        padding: 0,
      }}>
        SMALL BUSINESS
      </div>
      <div style={{
        fontSize: 22,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#07527F',
        textAlign: 'center',
        lineHeight: 1.2,
        padding: 0,
      }}>
        QUOTING
      </div>
    </div>
  </div>
)

const NextGenerationHighlight = () => (
  <div style={{
    width: 300,
    height: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    backgroundColor: '#F8F8F6',
  }}>
    <img
      src={nextGen}
      width="45px"
      height="75px"
      alt="mobile divice icon"
      style={{
        position: 'absolute',
        bottom: 200,
      }}
    />
    <div style={{
      // marginTop: 25,
      width: 260,
      height: 260,
      borderRadius: 150,
      backgroundColor: '#F8F8F6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      fontFamily: '',
      paddingTop: 80,
    }}>
      <div style={{
        fontSize: 16,
        fontFamily: 'montserrat medium',
        color: '#3C5C45',
        textAlign: 'center'
      }}>
        NEXT GENERATION OF
      </div>
      <div style={{
        fontSize: 54,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#849F76',
        textAlign: 'center',
        lineHeight: 1,
        padding: 0,
        paddingBottom: 6
      }}>
        eDOCS
      </div>
      <div style={{
        fontSize: 16,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        textAlign: 'center'
      }}>
        BILLING & CLAIMS eDOCS
      </div>
      <div style={{
        fontSize: 22,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#849F76',
        textAlign: 'center',
        lineHeight: 1.5,
        padding: 0,
        // paddingBottom: 6
      }}>
        NOTIFICATIONS
      </div>
      <div style={{
        fontSize: 16,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        textAlign: 'center'
      }}>
        ROLL OUT
      </div>
    </div>
  </div>
)

const FirstInsurer = () => (
  <div style={{
    width: 300,
    height: 300,
    borderRadius: '50%',
    backgroundColor: '#E4E8DE',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    
  }}>
    <div style={{
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      bottom: 185,
    }}>
      <Odom number={1} text="st" format="(,ddd).dd" odomStyle={{
        fontSize: 72,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1C1F3D',
        lineHeight: 1,
        padding: 0,
        textAlign: 'right'
      }}
        textStyle={{
          fontSize: 48,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#1C1F3D',
          lineHeight: 1,
          padding: 0
        }}
      />
    </div>
    <div style={{
      // margin: 25,
      marginTop: 50,
      width: 260,
      height: 260,
      borderRadius: 130,
      // backgroundColor: '#E4E8DE',
      display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      flexDirection: 'column',
      fontFamily: '',
      padding: 16,
      paddingTop: 50,
    }}>
      <div style={{
        fontSize: 18,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        textAlign: 'center',
        lineHeight: 1.5,
        // padding: 0,
        paddingBottom: 6
      }}>
        insurer <br />earns the new Billing eDocs certification: <div style={{ color: 'black', fontSize: 22 }}>The Wawanesa Mutual Insurance Company</div>
      </div>
    </div >
  </div>
)

const FirstInTheIndustryJSONAPI = () => (
  <div style={{
    width: 300,
    height: 300,
    borderRadius: '50%',
    backgroundColor: '#F8F9F6',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}>
    <div style={{
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      bottom: 180,
    }}>
      <div style={{ fontSize: 72, marginBottom: 8, color: '#EECA41', marginRight: 6 }}>
        {JSON1}
      </div>
      <Odom number={1} text="st" odomStyle={{
        fontSize: 72,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        lineHeight: 1,
        padding: 0
      }}
        textStyle={{
          fontSize: 48,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#1B526D',
          lineHeight: 1,
          padding: 0
        }}
      />
      <div style={{ fontSize: 72, marginBottom: 8, color: '#EECA41', marginLeft: 12 }}>
        {JSON2}
      </div>
    </div>
    <div style={{
      // margin: 25,
      marginTop: 62,
      width: 260,
      height: 260,
      borderRadius: 130,
      // backgroundColor: '#F8F9F6',
      display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      flexDirection: 'column',
      fontFamily: '',
      padding: 18,
      paddingTop: 54,
    }}>
      <div style={{
        fontSize: 19,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#48604C',
        textAlign: 'center',
        lineHeight: 1.5,
        // padding: 0,
        paddingBottom: 6
      }}>
        in the industry<br /> <span style={{ color: '#1C1F3D', fontSize: 21 }}>JSON API Standards</span> launch for personal and commercial lines<br /> policy inquiry
      </div>
    </div >
  </div>
)

const FirstInsurerAndVendor = () => (
  <div style={{
    width: 300,
    height: 300,
    borderRadius: '50%',
    backgroundColor: '#E8EFF2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    
  }}>
    <div style={{
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      bottom: 180,
    }}>
      <img
        src={medalIcon}
        width="64px"
        height="79px"
        alt="medal icon"
      />
      <Odom number={1} text="st" odomStyle={{
        fontSize: 72,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#EECA41',
        lineHeight: 1,
        padding: 0
      }}
        textStyle={{
          fontSize: 48,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#EECA41',
          lineHeight: 1,
          padding: 0
        }}
      />
    </div>
    <div style={{
      // margin: 25,
      marginTop: 70,
      width: 260,
      height: 260,
      borderRadius: 130,
      // backgroundColor: '#E8EFF2',
      display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      flexDirection: 'column',
      fontFamily: '',
      padding: 16,
      paddingTop: 54,
    }}>
      <div style={{
        fontSize: 17,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        // color: '#1B526D',
        textAlign: 'center',
        paddingTop: 8,
        // lineHeight: 1.5,
        // padding: 0,
        // paddingBottom: 6
      }}>
        insurer and vendor,<br /> <span style={{ color: '#849F76', fontSize: 22, lineHeight: .9 }}> Unica Insurance </span> and <span style={{ color: '#849F76', fontSize: 22, lineHeight: .9 }}> Vertafore</span>, complete all three levels of Commercial Lines Certification
      </div>
    </div >
  </div>
)

const OneHundredSixtyOnePercent = () => (
  <div style={{
    width: 300,
    height: 300,
    borderRadius: '50%',
    backgroundColor: '#FDF7E0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    
  }}>
    <div style={{
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      bottom: 230,
    }}>
      <img
        src={greenUpArrow}
        width="56px"
        height="56px"
        alt="up arrow"
      />
    </div>
    <div style={{
      marginTop: 48,
      width: 260,
      height: 260,
      borderRadius: 130,
      // backgroundColor: '#FDF7E0',
      display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      flexDirection: 'column',
      fontFamily: '',
      padding: 16,
      paddingTop: 16,
    }}>
      <div style={{ height: 78}}>
        <Odom number={161} text="%" odomStyle={{
          fontSize: 60,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#1B526D',
          marginTop: 0
        }}
          textStyle={{
            fontSize: 60,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1B526D',
            marginTop: 32
          }}
        />
      </div>
      <div style={{
        fontSize: 24,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        textAlign: 'center',
        lineHeight: 1,
        padding: 0,
        // paddingBottom: 6
      }}>
        INCREASE
      </div>
      <div style={{
        fontSize: 18,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#8A9D76',
        textAlign: 'center'
      }}>
        IN eSLIPS AND POLICY DOCUMENTS SENT <span style={{ color: '#48604C' }}>DIGITALLY</span> THROUGH <span style={{ color: '#48604C' }}>MPOI</span>
      </div>
    </div >
  </div>
)

const FourMillion = () => (
  <div style={{
    width: 300,
    height: 300,
    borderRadius: '50%',
    backgroundColor: '#E9ECE1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    
  }}>
    <img
      src={blueTooth}
      width="80px"
      height="58px"
      alt=""
      style={{
        position: 'absolute',
        bottom: 220,
      }}
    />
    <div style={{
      marginTop: 45,
      width: 260,
      height: 260,
      borderRadius: 150,
      // backgroundColor: '#E9ECE1',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      fontFamily: '',
      paddingTop: 16,
    }}>
      <div style={{
        fontSize: 28,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1C1F3D',
        textAlign: 'center',
        lineHeight: 1,
        padding: 0,
      }}>
        Close to
      </div>
      <Container style={{ marginBottom: 0, height: 72 }}>
        <Odom number={4} text="M"
          textStyle={{
            fontSize: 72,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1C1F3D',
            lineHeight: 1,
            paddingBottom: 0,
            marginBottom: 0,
            paddingTop: 6,
            paddingLeft: 6
          }}
          odomStyle={{
            fontSize: 72,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1C1F3D',
            lineHeight: 1,
            // paddingBottom: -20,
          }} />
      </Container>

      <div style={{
        fontSize: 16,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        textAlign: 'center'
      }}>
        <span style={{
          fontSize: 42,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#849F76',
          textAlign: 'center',
          lineHeight: 1,
          padding: 0,
          // paddingBottom: 6
        }}>
          eDocs
        </span><br />transactions<br /> every month
      </div>
    </div>
  </div>
)

export const Odom = ({ number, text, odomStyle, textStyle, style, preText, preTextStyle, format, xs }) => {
  const [odoVal, setOdoVal] = useState(number === 1 ? 9 : 0);
  const odomRef = useRef(null);

  useEffect(() => {
    const triggerAnimation = () => {
      if (odoVal !== number && odomRef && odomRef.current && odomRef.current.getBoundingClientRect().top < window.innerHeight) {
        setOdoVal(number);
      };
    }
    window.addEventListener('scroll', triggerAnimation);
    triggerAnimation();
    return () => window.removeEventListener('scroll', triggerAnimation);
  }, [number, odoVal]);

  return (
    <Col xs={xs}>
      <Row ref={odomRef} style={{
        display: 'flex',
        justifyContent: 'center',
        ...style
      }}>
        {preText && <p style={preTextStyle || odomStyle}>
          {preText}
        </p>}
        <div
          style={odomStyle}>
          <Odometer
            format={format || "d"}
            // duration={number === 1 ? 2000 : 500}
            duration={2000}
            selector='.my-numbers'
            value={odoVal}
            // animation={number === 1 ? "count" : ''}
            animation="count"
          />
        </div>
        {text && <p style={textStyle || odomStyle}>
          {text}
        </p>}
      </Row>
    </Col>
  );
}
